export const setLocalData = async () => {
  if (!localStorage) {
    alert("Local Storage is not supported! Please open in a new browser.");
  } else {
    localStorage.setItem("html-code", files["index.html"].value);
    localStorage.setItem("css-code", files["style.css"].value);
    localStorage.setItem("js-code", files["script.js"].value);
  }
};

export const files = {
  "index.html": {
    name: "index.html",
    language: "html",
    value: `<!DOCTYPE html>
<html>
  <head>
    <title>Page Title</title>
    <!--- Head HTML goes here -->
    
    
    
    
    <!--- Link to styles in CSS tab -->
    <link rel='stylesheet' type='text/css' media='screen' href='main.css'>
  </head>
  <body>
    <!--- Paste HTML below here -->
    
    
    
    

    <!--- Link to code in JavaScript tab -->
    <script src="script.js"></script>
  </body>
</html>`,
  },
  "style.css": {
    name: "main.css",
    language: "css",
    value: `/* CSS Selectors go here */

h1 {
  display: block;
  font-size: 2em;
  font-weight: bold;
}

button {
  margin: 10px;
  padding: 10px;
  cursor: pointer;
}`,
  },
  "script.js": {
    name: "main.js",
    language: "javascript",
    value: `// JavaScript code goes here

function myFunction() {
  document.querySelector("#replace").innerHTML = "Hello World!";
}`,
  },
};

export const options = {
  acceptSuggestionOnCommitCharacter: true,
  acceptSuggestionOnEnter: "on",
  accessibilitySupport: "auto",
  autoClosingBrackets: "always",
  autoIndent: "full",
  automaticLayout: true,
  bracketPairColorization: {
    enabled: true,
  },
  codeLens: true,
  colorDecorators: true,
  cursorBlinking: "blink",
  cursorSmoothCaretAnimation: "off",
  cursorStyle: "line",
  disableLayerHinting: false,
  disableMonospaceOptimizations: false,
  dragAndDrop: false,
  fixedOverflowWidgets: false,
  folding: true,
  foldingStrategy: "auto",
  fontLigatures: false,
  formatOnPaste: true,
  formatOnType: true,
  hideCursorInOverviewRuler: false,
  links: true,
  mouseWheelZoom: false,
  multiCursorMergeOverlapping: true,
  multiCursorModifier: "alt",
  overviewRulerBorder: true,
  overviewRulerLanes: 2,
  quickSuggestions: true,
  quickSuggestionsDelay: 100,
  readOnly: false,
  renderControlCharacters: false,
  renderFinalNewline: "on",
  renderLineHighlight: "all",
  renderWhitespace: "none",
  revealHorizontalRightPadding: 30,
  roundedSelection: true,
  rulers: [],
  scrollBeyondLastColumn: 5,
  scrollBeyondLastLine: true,
  selectOnLineNumbers: true,
  selectionClipboard: true,
  selectionHighlight: true,
  showFoldingControls: "mouseover",
  smoothScrolling: false,
  suggestOnTriggerCharacters: true,
  wordBasedSuggestions: true,
  wordSeparators: "~!@#$%^&*()-=+[{]}|;:'\",.<>/?",
  wordWrap: "off",
  wordWrapBreakAfterCharacters: "\t})]?|&,;",
  wordWrapBreakBeforeCharacters: "{([+",
  wordWrapColumn: 80,
  wrappingIndent: "none",
  minimap: {
    enabled: true,
  },
  contextmenu: false,
  fontSize: 16,
  fontFamily: "Courier New",
  lineNumbers: "on",
  lineDecorationsWidth: 2,
  lineNumbersMinChars: 3,
  scrollbar: {
    vertical: "hidden",
  },
};

